import { useCallback, useState } from 'react';
import { logError } from '../../../../../shared/error/logError';
import { useTokenizedCardsStore } from './useTokenizedCardsStore';

export function useDeleteTokenizedCard(id: string) {
	const store = useTokenizedCardsStore();
	const [isDeleting, setIsDeleting] = useState(false);

	const deleteTokenizedCard = useCallback(async () => {
		setIsDeleting(true);

		await store.delete(id).catch((error) => {
			logError(error);
			setIsDeleting(false);
		});

		/*
		NB: After a successful deletion we don't reset `isDeleting` state to false,
		because the component is already unmounted by then. Setting the state of
		unmounted component would cause a warning of a potential memory leak.
		*/
	}, [store]);

	return { deleteTokenizedCard, isDeleting };
}
